export default __webpack_public_path__ + "static/media/bulk.78d1a63d.svg";